module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ml-fa530666ce9e170dc6cdcc03b6ef2f68.svg";